// This will load the uppermost modal box with the size settings from whatever is opened
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    size: String,
    noPadding: Boolean
  }

  connect() {
    console.log('Connecting modal size controller')
    let sizeClasses = [];

    switch (this.sizeValue) {
    case 'small':
      sizeClasses = ['max-w-lg'];
      break;
    case 'medium':
      sizeClasses = ['max-w-3xl'];
      break;

    // Large and huge should also fix the height of the dialog
    case 'large':
      sizeClasses = ['max-w-7xl'];
      break;
    case 'large-fixed':
      sizeClasses = ['max-w-7xl', 'h-7/8'];
      break;
    case 'huge':
      sizeClasses = ['max-w-full', 'h-full'];
      break;
    default:
      sizeClasses = ['max-w-3xl'];
    }

    // This needs to get the modal's dialog only
    const openModals = document.querySelectorAll('[data-p="modal"] > [role="dialog"]');
    if (openModals.length > 0) {
      // Target the last openModal
      const targetModal = openModals[openModals.length - 1];
      targetModal.classList.remove('max-w-3xl');
      sizeClasses.forEach((sizeClass) => {
        targetModal.classList.add(sizeClass);
      });

      if (this.noPaddingValue) {
        targetModal.classList.add('p-0!');
      }
    }
  }
}
